const locale = "en-US";

const defaultOptions = {
	day: "numeric",
	month: "long",
};

const formatDate = (date, showShortMonth = false, options = defaultOptions,) => {
	const monthOption = showShortMonth ? { month: "short" } : {};
	const mergedOptions = { ...options, ...monthOption };
	return new Date(date).toLocaleDateString(locale, mergedOptions);
};

const formatDateWithYear = (date, options = defaultOptions) =>
	new Date(date).toLocaleString(locale, {
		...options,
		year: "numeric",
	});

const formatDateWithTime = (dateString) => {
	const date = new Date(dateString);
	const monthName = date.toLocaleString(locale, { month: "long" });
	const day = date.getDate();
	const hours = date.getHours() % 12 || 12;
	const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
	const period = date.getHours() >= 12 ? "PM" : "AM";

	return {
		date: `${monthName} ${day}`,
		time: `${hours}:${minutes} ${period}`
	};
};

const formatDateWithWeekday = (dateString) => {
	const date = new Date(dateString);
	const options = { weekday: "long", month: "long", day: "numeric" };
	return date.toLocaleDateString(locale, options);
};


const futureDateFormat = (daysToAdd, showWeekday) => {
	const futureDate = new Date();
	futureDate.setDate(futureDate.getDate() + daysToAdd);
	return showWeekday ? formatDateWithWeekday(futureDate, true) : formatDate(futureDate, true);
};



export {
	formatDate,
	formatDateWithYear,
	formatDateWithTime,
	formatDateWithWeekday,
	futureDateFormat,
};
